import { gql } from "@apollo/client";

export const GET_MEMBERS = gql`
  query Members {
    members {
        id
        First_Name
        Mobile_Number
        Payment_Status
        ID_Card
        Last_Name
        DOB
        City
        District
        State
        Pincode
        Email
        Role
        Occupation
        Payment_Id
        Pan_Number
        Pan_Card
        ID_Proof_Number
        ID_Proof_Type
        Marital_Status
        isDeleted
        Address
        Payment_Method
        Payment_Date
        Family_Details
        Star
        Raasi
        Kootram
        Kuladeivam
    }
  }
`;

export const GET_MEMBER_DETAILS = gql`
  query Member($mobile: String!) {
    member(mobile: $mobile) {
      id
      First_Name
      Last_Name
      Mobile_Number
      DOB
      City
      District
      State
      Pincode
      Email
      Role
      Occupation
      Address
      isDeleted
      Marital_Status
      ID_Card
      Family_Details
      ID_Proof_Type
      ID_Proof_Number
      Pan_Card
      Pan_Number
      Payment_Id
      Payment_Status
      Payment_Method
      Payment_Date
      Star
      Raasi
      Kootram
      Kuladeivam
      
    }
  }
`;

// Query to check if a mobile number already exists
export const CHECK_DUPLICATE_MOBILE = gql`
  query CheckDuplicate($field: String!, $value: String!) {
    checkDuplicate(field: $field, value: $value)
  }
`;

// You can add other queries here as needed
export const GET_USER_BY_MOBILE = gql`
  query GetUserByMobile($mobile: String!) {
    getUserByMobile(mobile: $mobile) {
      id
      mobile
      name
      email
    }
  }
`;
